import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import { useOfferPriceWithMember } from 'hooks/Offers/useOfferPrice'
import useOfferTilePriceBlockExperiment from 'hooks/Experiments/useOfferTilePriceBlockExperiment'
import OfferTilePriceBlockSavingsLabel from 'components/OfferList/OfferListTiles/Support/OfferTilePriceBlockSavingsLabel'
import OfferTilePriceBlockCaption from 'components/OfferList/OfferListTiles/Support/OfferTilePriceBlockCaption'

interface Props {
  captionText: string
  memberPrice: number
  price: number
  value: number
  duration: number
  roomCount?: number
  offer: App.BedbankOffer | App.Offer | App.OfferSummary
  showValueDiscount: boolean
  discount?: number
  saleUnit?: string
  checkIn?: string
  checkOut?: string
}

function BaseOfferPriceContent({ captionText, memberPrice, price, value, duration, roomCount, saleUnit, showValueDiscount, discount, offer, checkIn, checkOut }: Props) {
  const {
    saleUnit: displaySaleUnit,
    total: displayPrice,
    memberTotal: displayMemberPrice,
    value: displayValue,
  } = useOfferPriceWithMember({
    value,
    saleUnit: saleUnit ?? 'total',
    duration,
    total: price,
    memberTotal: memberPrice,
  })
  const priceBlockVariation = useOfferTilePriceBlockExperiment(offer, offer.type === 'bedbank_hotel' ? true : undefined, displayPrice > 0)
  return (
    <>
      {priceBlockVariation && <OfferTilePriceBlockSavingsLabel
        offer={offer}
        price={displayPrice}
        memberPrice={displayMemberPrice}
        discountPercentage={showValueDiscount ? discount : undefined}
        variation={priceBlockVariation}
        offerConfig={offer.luxPlus}
      />}
      <OfferTilePriceBlockCaption
        priceBlockExperimentVariation={priceBlockVariation}
        duration={duration}
        unitCount={roomCount}
        saleUnit={saleUnit ?? offer.saleUnit}
        checkIn={checkIn}
        checkOut={checkOut}
      >{captionText}
      </OfferTilePriceBlockCaption>
      <LuxPlusPriceStack
        price={displayPrice}
        memberPrice={displayMemberPrice}
        size="S"
        saleUnit={displaySaleUnit}
        offerConfig={offer.luxPlus}
        presentation={priceBlockVariation ? 'price-block-experiment' : undefined}
      />
      {showValueDiscount && !!displayValue && (!priceBlockVariation || offer.type !== 'bedbank_hotel') && <PriceRowValueDiscountWithCaption
        weight={priceBlockVariation ? 'normal' : undefined}
        colour={priceBlockVariation ? 'light-foreground-alt' : undefined}
        size="M"
        originalValue={displayValue}
        discountPercentage={priceBlockVariation ? undefined : discount}
      />}
    </>
  )
}

export default BaseOfferPriceContent
